import React from "react";
import { useImage } from "./use-image";
import { InsWidget, InsWidgetTitle } from "components";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
import "./insDescriptionWidget.scss";
const { nodata } = language.en.common;
export const InsDescriptionWidget = (props) => {
    const { sectionId, widgetId } = props;
    const [[response], datapointsQueryState] = useGetDatapointsWidgetData(props);
    const widgetData = response?.data[0];
    const [imageSrc, imageQueryState] = useImage(widgetData?.imageUrl, widgetData?.imageIsExternalContent);
    const imageUrl = widgetData?.imageIsExternalContent ? widgetData?.imageUrl : imageSrc;
    const queryState = {
        isFinished: !widgetData || widgetData?.imageIsExternalContent ? datapointsQueryState?.isFinished : imageQueryState?.isFinished,
        isPending: !widgetData || widgetData?.imageIsExternalContent ? datapointsQueryState?.isPending : imageQueryState?.isPending
    };
    const content = React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: Boolean(imageUrl || widgetData?.text) },
        React.createElement("div", null,
            React.createElement("div", { className: "description-widget" },
                imageUrl && React.createElement("img", { src: imageUrl, className: "image", alt: "" }),
                React.createElement("div", { className: "description" }, widgetData?.text || nodata))));
    return (React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, content: content, title: React.createElement(InsWidgetTitle, { ...props }) }));
};
